/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TokenType {
    ACH = 'ACH',
    CC = 'CC',
}